import { Controller } from "@hotwired/stimulus";

const TYPE_DELAY = 30;
const THINKING_TIME = 1400;
const PAUSE_BETWEEN = 2600;
const BOTTOM_SLACK = 24;

export default class extends Controller {
  static targets = ["log", "exchange", "answer"];
  static values = { prompts: Array };

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    this.index = 1;
    this.busy = false;
    this.following = true;
    this.logTarget.addEventListener("scroll", this.trackFollowing);
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.inView = entry.isIntersecting;
        if (this.inView && !this.busy) this.next();
      },
      { rootMargin: "-30% 0px -30% 0px" },
    );
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
    this.logTarget.removeEventListener("scroll", this.trackFollowing);
    clearTimeout(this.timer);
  }

  next() {
    if (this.index >= this.promptsValue.length) return;

    this.busy = true;
    const exchange =
      this.exchangeTarget.content.firstElementChild.cloneNode(true);
    this.logTarget.append(exchange);
    this.type(exchange, this.promptsValue[this.index], 1);
  }

  type(exchange, text, length) {
    const prompt = exchange.querySelector("[data-slot=prompt]");
    prompt.hidden = false;
    prompt.textContent = text.slice(0, length);
    this.follow();

    if (length < text.length) {
      this.wait(TYPE_DELAY, () => this.type(exchange, text, length + 1));
    } else {
      exchange.querySelector("[data-slot=thinking]").hidden = false;
      this.follow();
      this.wait(THINKING_TIME, () => this.answer(exchange));
    }
  }

  answer(exchange) {
    exchange.querySelector("[data-slot=thinking]").remove();
    exchange
      .querySelector("[data-slot=answer]")
      .append(this.answerTargets[this.index].content.cloneNode(true));
    this.follow();
    this.index += 1;

    this.wait(PAUSE_BETWEEN, () => {
      this.busy = false;
      if (this.inView) this.next();
    });
  }

  trackFollowing = () => {
    const { scrollHeight, scrollTop, clientHeight } = this.logTarget;
    this.following = scrollHeight - scrollTop - clientHeight < BOTTOM_SLACK;
  };

  follow() {
    if (this.following) this.logTarget.scrollTop = this.logTarget.scrollHeight;
  }

  wait(delay, callback) {
    this.timer = setTimeout(callback, delay);
  }
}
